/* unplugin-vue-components disabled */import script from "./common_foot.vue?vue&type=script&setup=true&lang=js"
export * from "./common_foot.vue?vue&type=script&setup=true&lang=js"

import "./common_foot.vue?vue&type=style&index=0&id=89263fdc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89263fdc"]])

export default __exports__